import { InjectionToken } from '@angular/core';
import { from, map, Observable } from 'rxjs';
import type { Font, Lang, Plugin } from '@pdfme/common';

export interface PdfmeConfig {
  // Fonts are project-specific (each app ships its own faces), so they are provided
  // per-app via the PDFME_CONFIG token — never defaulted here.
  fonts: () => Observable<Font>;
  plugins: () => Observable<Record<string, Plugin<any>>>;
  supportedLangs: Lang[];
  fallbackLang: Lang;
}

export const DEFAULT_FONT_SIZE = 10;

export const DEFAULT_PDFME_PLUGINS = (): Observable<Record<string, Plugin<any>>> => {
  return from(import('@pdfme/schemas')).pipe(
    map(schemas => ({
      text: schemas.text,
      image: schemas.image,
      signature: schemas.signature,
      table: schemas.table,
      qrcode: schemas.barcodes['qrcode'],
      line: schemas.line,
      rectangle: schemas.rectangle,
      ellipse: schemas.ellipse,
      circleMark: schemas.circleMark,
      date: schemas.date,
      time: schemas.time,
      dateTime: schemas.dateTime
    }))
  );
};

export const PDFME_CONFIG = new InjectionToken<PdfmeConfig>('PDFME_CONFIG');
